// extracted by mini-css-extract-plugin
module.exports = {"item":"PanelGroupCheckbox__item","itemActive":"PanelGroupCheckbox__itemActive","itemDisabled":"PanelGroupCheckbox__itemDisabled","input":"PanelGroupCheckbox__input"};